//#region Imports

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserProxy } from '../../models/proxys/user.proxy';

//#endregion

@Injectable({
  providedIn: 'root',
})
export class UserService {

  //#region Private Properties

  private shouldRequestPasswordChange: boolean = false;
  private readonly currentUser$: BehaviorSubject<UserProxy | null>;

  //#endregion

  //#region Constructor

  constructor() {
    const initialUser = this.getCurrentUser();
    this.currentUser$ = new BehaviorSubject<UserProxy | null>(initialUser);
  }

  //#endregion

  //#region Public Methods

  public getCurrentUser$(): Observable<UserProxy | null> {
    return this.currentUser$.asObservable();
  }

  public getCurrentUser(): UserProxy | null {
    try {
      const user = JSON.parse(localStorage.getItem(environment.keys.user) || '');
      if (!user) return null;
      
      const userWithFlag = user as any;
      if (userWithFlag.shouldRequestPasswordChange === true) {
        this.shouldRequestPasswordChange = true;
      }
      
      return user;
    } catch (e) {
      return null;
    }
  }

  public getShouldRequestPasswordChange(): boolean {
    return this.shouldRequestPasswordChange;
  }

  public setShouldRequestPasswordChange(value: boolean): void {
    this.shouldRequestPasswordChange = value;
  }

  public processUserFromApi(user: UserProxy | null): UserProxy | null {
    if (!user) {
      this.shouldRequestPasswordChange = false;
      return null;
    }

    const userWithFlag = user as any;
    if (userWithFlag.shouldRequestPasswordChange === true) {
      this.shouldRequestPasswordChange = true;
      const { shouldRequestPasswordChange, ...userWithoutFlag } = userWithFlag;
      return userWithoutFlag as UserProxy;
    } else {
      this.shouldRequestPasswordChange = false;
      return user;
    }
  }

  public refreshCurrentUser(): void {
    const user = this.getCurrentUser();
    if (user) {
      const userWithFlag = user as any;
      if (userWithFlag.shouldRequestPasswordChange === true) {
        this.shouldRequestPasswordChange = true;
      }
    }
    this.currentUser$.next(user);
  }

  public saveUserToLocalStorage(user: UserProxy | null): void {
    if (!user) {
      localStorage.removeItem(environment.keys.user);
      return;
    }

    const userWithFlag = user as any;
    if (userWithFlag.shouldRequestPasswordChange !== undefined) {
      const { shouldRequestPasswordChange, ...userWithoutFlag } = userWithFlag;
      localStorage.setItem(environment.keys.user, JSON.stringify(userWithoutFlag));
    } else {
      localStorage.setItem(environment.keys.user, JSON.stringify(user));
    }
  }

  //#endregion

}
